
import type { Option } from "components/common/utlis/TypeAnnotations";
import {
    SET_DROPDOWN_DATA,
} from "../../annotation/PlanningConstants";

// Function to calculate total percentage including the new input
export const calculateTotalPercentage = (newValue: number, state: any, index: number) => {

    // Clone existing allocations from state
    const existingAllocations = [...state.internalInfoDetails.allocations];
    let total = 0;

    // Sum all percentages except the current one being edited
    existingAllocations.forEach((alloc, i) => {
        if (i !== index) {
            total += Number(alloc.percentage) || 0;
        }
    });

    return total + newValue;
};

export const setParitarCommitteDropdown = async (
    office: Option,
    pcLists: any,
    dispatch: React.Dispatch<any>
) => {
    const isCSelected = office?.label.startsWith('C');

    const pcOptions = pcLists.filter((option: any) =>
        isCSelected ? option.label.includes('124') : !option.label.includes('124')
    );

    dispatch({ type: SET_DROPDOWN_DATA, payload: { pcOptions } });
};

export const setEmployeeTypesDropdown = async (
    pc: Option,
    empLists: any,
    dispatch: React.Dispatch<any>
) => {
    const isCSelected = pc?.label.startsWith('C');

    const pcOptions = empLists.filter((option: any) =>
        isCSelected ? option.label.includes('124') : !option.label.includes('124')
    );

    dispatch({ type: SET_DROPDOWN_DATA, payload: { pcOptions } });
};

export const localToEnglishMap: Record<string, string> = {
    "Bruxelles": "Brussel",
    "Brussels": "Brussel",
};

export const getCityNameInEnglish = (name: string): string => {
    return localToEnglishMap[name] || name;
};
